import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`;

export const Heading = styled.h1`
    font-family: "Suisse International", sans-serif;
    font-size: 35px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

`

export const Paragraph = styled.p`
    color: #757575;
    text-align: center;
    font-family: Inter, serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
`


export const Card = styled.div`
    background: white;
    border-radius: 16px;
    border: 1px solid #667085;
    padding: 32px;
    width: 100%;
    max-width: 320px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const NumberCircle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 500;
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  text-align: left;
`;

export const Subtitle = styled.p`
  font-size: 16px;
  color: #667085;
  margin: 0;
  line-height: 1.5;
  text-align: left;
  font-family: 'Inter';
`;

export const ImageContainer = styled.div`
    overflow: hidden;
    position: relative;
    padding-left: 40px;
    opacity: 0.5;
    margin-right: -32px;
    height: 70%;
    display: flex;
`;

export const Image = styled.img`
  object-fit: cover;
`;

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));
  gap: 24px;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px;
  justify-items: center;
`;

export const ButtonWrapper = styled.button`
    width: 100%;

    @media (min-width: 768px) {
        width: 418px;
    }
`
